export default "__VITE_ASSET__f4079504__"